import orderBy from 'lodash/orderBy';
import { createReducer } from '@reduxjs/toolkit';
import { setActiveCountryItem, setActiveLanguageItem, setCountryList, } from '@yme/components/FooterBottomMenu/redux/actions';
import { setPriceHeroInfo, setYouFinanceText } from '@yme/pdp-components/ProductCard';
import { getPDPLinksSuccess, setCurrentSku, setPageProperties, setLocationMismatchInitialCountry, setLocationMismatchInitialLanguage, setCurrencyRateData, } from './action';
const initialState = {
    data: [],
    countries: [],
    languages: [],
    labels: {},
    language: '',
    anniversary70thLogoPagePath: '',
    currentCountryRoot: '',
    currentLanguageRoot: '',
    initialCountryRoot: '',
    initialLanguageRoot: '',
    instantFinanceQuoteLink: '',
    outboardEnginesSelectionLink: '',
    configuratorLeadFormPagePath: '',
    isFinanceCalculatorEnabled: false,
    financeCalculatorPluginSourcePath: '',
    isRightToLeft: false,
    isShowDriverLicenseEnabled: false,
    is35kwFilterDisabled: false,
    isInAuthor: false,
    youFinanceText: '',
    priceHeroInfo: '',
    is70thLogoEnabled: false,
    ecommerceEnabled: false,
    isInstallmentEnabled: false,
    isCycleSchemeEnabled: false,
    isNavDarkModeEnabled: false,
    isAuthenticationEnabled: false,
    isTestRideEnabled: false,
    isNavLoggedInIndicatorEnabled: false,
    ecommerceId: {
        sku: '',
        slug: '',
    },
    languageRootPath: '',
    commercetoolsProjectKey: '',
    isOmnibusRegulationEnabled: false,
    pdpLinks: {},
    externalCart: {
        isExternalCartEnabled: false,
        hostettlerEndPoints: {
            domain: '',
            cartInfoEndPoint: '',
            addToCartEndPoint: '',
            cartLinkEndPoint: '',
        },
    },
    pageType: '',
    locale: '',
    isoCountryCode: '',
    locationMismatchModalModel: {
        labels: {},
        countries: [],
        initialCountry: '',
        initialLanguage: '',
    },
    isNewsletterSubscriptionEnabled: false,
    isSearchEnabled: false,
    isMotorcycleVariationsEnabled: false,
    isKioskVersion: false,
    isVisualWebsiteOptimizerEnabled: false,
    dealerLocatorPageUrl: '',
    financeCalculatorLeadFormPagePath: '',
    bloomreachModel: {
        accountId: '',
        autosuggestHost: '',
        domainKey: '',
        searchHost: '',
        contentCatalog: '',
        productCatalog: '',
    },
    searchResultsPageUrl: '',
    backgroundImage: {
        src: '',
        srcSet: [],
    },
    kioskPreferredDealers: [],
    currencyRate: null,
    isCurrencyConverterEnabled: false,
};
export function changeLanguageList(countries, currentCountry) {
    const activeCountry = countries.find((country) => country.code === currentCountry);
    return orderBy(activeCountry?.languages || [], [
        (language) => language.code === activeCountry?.defaultLanguageCode,
        'desc',
    ]);
}
function currentSkuReducer(state, { payload }) {
    return {
        ...state,
        ecommerceId: {
            ...state.ecommerceId,
            sku: payload,
        },
    };
}
function youFinanceTextReducer(state, { payload }) {
    return {
        ...state,
        youFinanceText: payload,
    };
}
function priceHeroInfoReducer(state, { payload }) {
    return {
        ...state,
        priceHeroInfo: payload,
    };
}
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setYouFinanceText, youFinanceTextReducer)
        .addCase(setPriceHeroInfo, priceHeroInfoReducer)
        .addCase(setCurrentSku, currentSkuReducer)
        .addCase(setCountryList, (state, action) => ({
        ...state,
        countries: action.payload,
        languages: changeLanguageList(action.payload, state.currentCountryRoot),
    }))
        .addCase(setActiveCountryItem, (state, action) => {
        const languages = changeLanguageList(state.countries, action.payload);
        return {
            ...state,
            currentCountryRoot: action.payload,
            currentLanguageRoot: languages[0]?.code,
            languages: languages || [],
        };
    })
        .addCase(setActiveLanguageItem, (state, action) => ({
        ...state,
        currentLanguageRoot: action.payload,
    }))
        .addCase(setPageProperties, (state, action) => ({
        ...state,
        ...action.payload,
        ...{
            initialCountryRoot: action.payload.currentCountryRoot,
            initialLanguageRoot: action.payload.currentLanguageRoot,
        },
        locationMismatchModalModel: {
            ...action.payload.locationMismatchModalModel,
            initialCountry: state.locationMismatchModalModel.initialCountry,
            initialLanguage: state.locationMismatchModalModel.initialLanguage,
        },
    }))
        .addCase(getPDPLinksSuccess, (state, action) => ({
        ...state,
        pdpLinks: action.payload.data,
    }))
        .addCase(setLocationMismatchInitialCountry, (state, action) => {
        return {
            ...state,
            locationMismatchModalModel: {
                ...state.locationMismatchModalModel,
                initialCountry: action.payload,
            },
        };
    })
        .addCase(setLocationMismatchInitialLanguage, (state, action) => {
        return {
            ...state,
            locationMismatchModalModel: {
                ...state.locationMismatchModalModel,
                initialLanguage: action.payload,
            },
        };
    })
        .addCase(setCurrencyRateData, (state, action) => {
        return {
            ...state,
            currencyRate: action.payload,
        };
    });
});
